<template>
  <div>
    <button class="m-aside-left-close m-aside-left-close--skin-light" id="m_aside_left_close_btn">
      <i class="la la-close"></i>
    </button>
    <div id="m_aside_left" class="m-grid__item m-aside-left m-aside-left--skin-light">
      <!-- BEGIN: Aside Menu -->
      <div
        id="m_ver_menu"
        class="m-aside-menu m-aside-menu--skin-light m-aside-menu--submenu-skin-light"
        m-menu-vertical="1"
        m-menu-scrollable="1"
        m-menu-dropdown-timeout="500"
        style="position: relative;"
      >
        <ul class="m-menu__nav m-menu__nav--dropdown-submenu-arrow">
          <li class="corp-prof-item">
            <div class="corp-box">
              <a href="#" class="corp-prof-img">
                <img src="../assets/MdtImages/corp-new.png" alt />
              </a>
              <a href="#" class="corp-prof-edit">
                <i class="flaticon-edit"></i>
              </a>
              <span class="corp-inf">{{this.tenantInfo.name}}</span>
            </div>
          </li>
          <li
            v-for="item in menuItems"
            v-bind:key="item.title"
            class="m-menu__item"
            :class="{ 'm-menu__item--submenu': item.children != null }"
            aria-haspopup="true"
            m-menu-submenu-toggle="hover"
          >
            <a :href="item.url" class="m-menu__link m-menu__toggle">
              <i class="m-menu__link-icon" :class="item.icon"></i>
              <span class="m-menu__link-text">{{ item.title }}</span>
              <i v-if="item.children != null" class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <div v-if="item.children != null" class="m-menu__submenu">
              <span class="m-menu__arrow"></span>
              <ul class="m-menu__subnav" v-for="ch in item.children" v-bind:key="ch.title">
                <li class="m-menu__item" aria-haspopup="true">
                  <a :href="ch.url" class="m-menu__link">
                    <span class="m-menu__link-text">{{ ch.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>

      <!-- END: Aside Menu -->
    </div>
  </div>
</template>
<script>
import menu from "../nav";
import { _getMyLicenses } from "../services/LicenseService";
import { _getMyTenantInfo } from "../services/TenantService";
export default {
  data() {
    return {
      menuItems: [],
      tenantInfo : {},
      token: localStorage.getItem("user-token")
    };
  },
  created() {
      this.getLicenses();
      this.getTenantInfo();
  },

  methods: {
    getLicenses() {
      _getMyLicenses().then(res => {
        var lst = [];
        var authorities = JSON.parse(
          localStorage.getItem("user")
        ).authorities.split(",");
        menu.items.forEach(function(item, index)
        {
          // start children control
          var children = [];
          if (item.children != null) {
            item.children.forEach(
              function(ch, index) {
              var found = ch.role.find(
                x => x == "*" || authorities.find(y => y == x)
              );
              if (found != null) children.push(ch);
            }
            );
            item.children = children;
          }
          // end children control
          if (item.lisance != null) {
            const found = res.data.data.licenses.some(
              x => x.moduleName == item.lisance
            );
            if (found) lst.push(item);
          } else lst.push(item);
        });
        this.menuItems = lst;
      });
    },
    getTenantInfo() {
  _getMyTenantInfo().then(response=> {
                 if(response.data.success)
        this.tenantInfo = response.data.data;
      })
    }
  }

};
</script>
